<template>
    <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow" class="content-formatted-text">
      <a v-if="hasLink" :href="data.link" :class="textClasses" :target="linkTarget">{{ data.displayText }}</a>
      <span v-else :class="textClasses">{{ data.displayText }}</span>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { FormattedTextModel } from '~/models';
import { contentTypes } from '~/models';
const typ = contentTypes.formatted_text;

const props = defineProps<{ model: FormattedTextModel, text: string }>();

const data = {
  displayText: props.text ?? props.model.elements.displayText.value,
  link: props.model.elements.link.value,
  textColor: props.model.elements.color.value[0]?.codename,
  isBold: multipleChoiceToBoolean(props.model.elements.bold),
  isItalic: multipleChoiceToBoolean(props.model.elements.italic),
  isUnderlined: multipleChoiceToBoolean(props.model.elements.underlined)
};

const hasLink = computed(() => !!data.link?.trim());

const textClasses = computed(() =>
  [
    data.isBold && 'bold',
    data.isItalic && 'italic',
    data.isUnderlined && 'underlined',
    data.textColor
  ].filter(Boolean).join(' ')
);

const linkTarget = computed(() => getLinkTarget(false, data.link))
</script>